import React from "react";
import PropTypes from "prop-types";
import { Wrapper, Paragraph, Link } from "../styles/form-steps-styles";

const ThankYou = ({ recruiterName }) => (
  <Wrapper data-test-id="applicant-review-thank-you-page">
    <Paragraph
      welcome
      className="animated fadeIn delay-1"
      center
      thankYouOne
      data-test-id="applicant-review-thank-you-paragraph"
    >
      We’ve let <strong>{recruiterName}</strong> know that they have a new
      review.
    </Paragraph>
    <Paragraph className="animated fadeIn delay-2" center thankYouTwo>
      Thanks for making our marketplace stronger, one review at a time.
    </Paragraph>
    <Paragraph className="animated fadeInUp delay-3" small center>
      Never heard of Hiring Hub before? Visit our{" "}
      <Link href="https://www.hiring-hub.com" title="Hiring Hub">
        website
      </Link>{" "}
      to learn more.
    </Paragraph>
  </Wrapper>
);

ThankYou.propTypes = {
  recruiterName: PropTypes.string.isRequired,
};

export default ThankYou;
